import { Select } from "components/UI/Select/SelectComponent";
import {
  changeDeferredTypeAction,
  deferredOptionsValidityAction,
  getDeferredOptions,
  switchIsDeferred,
  updateDeferredSelectValue,
} from "containers/Card/store/Actions";
import { CardAction } from "containers/Card/store/CardAction";
import { defaultTo, get } from "lodash";
import * as React from "react";
import {
  LocalizeContextProps,
  Translate,
  withLocalize,
} from "react-localize-redux";
import { connect } from "react-redux";
import { Col, Container, Input, Label, Row } from "reactstrap";
import { Dispatch } from "redux";
import { ThunkDispatch } from "redux-thunk";
import {
  CajitaStore,
  IDeferredOptionsProps,
  ISelectProps,
} from "root/store/CajitaStore";
/**
 * DeferredOptions Statefull Component
 */

class DeferredOptions extends React.Component<
  IDeferredOptionsProps & { enabled: boolean } & LocalizeContextProps
> {
  constructor(
    props: IDeferredOptionsProps & { enabled: boolean } & LocalizeContextProps
  ) {
    super(props);
    this._deferredTypeSelectHandler = this._deferredTypeSelectHandler.bind(
      this
    );
    this._selectHandler = this._selectHandler.bind(this);
  }

  public componentDidUpdate(prevProps: Readonly<IDeferredOptionsProps>): void {
    if (this._checkValidity() !== this.props.valid) this.props.updateValidity();
    // tslint:disable-next-line:early-exit
    if (
      this.props.card.binNumber.length === 8 &&
      prevProps.card.binNumber !== this.props.card.binNumber
    )
      this.props.fetchDeferredOptions(
        this.props.card.binNumber,
        defaultTo(get(this.props, "activeLanguage.code"), "es")
      );
  }

  public render(): React.ReactNode {
    if (!this.props.valid) return null;

    return (
      <Container fluid={true} className="section">
        <Row>
          <Col xs={6} style={{ paddingLeft: 2, paddingRight: 0 }}>
            <Label
              check={true}
              className={"checkbox-diners-text custom-container-card"}
            >
              <Input type="checkbox" onChange={this.props.switchIsDeferred} />
              <Translate id="deferredOptionsComponent.toggleTitle" />
            </Label>
          </Col>
          {this.props.enabled ? (
            <Col xs={6} className="select-month-section">
              <div>
                {this.props.deferredTypeSelect.value === "all" ? null : (
                  <div style={{ paddingBottom: 10 }}>
                    <Select
                      {...this.props.deferredTypeSelect}
                      change={this._deferredTypeSelectHandler}
                    />
                  </div>
                )}
                <div style={{ paddingBottom: 10 }}>
                  <Select
                    {...this.props.monthsSelect}
                    change={this._selectHandler}
                  />
                </div>
                {this.props.monthsOfGraceSelect.inputItems.length > 0 ? (
                  <div style={{ paddingBottom: 10 }}>
                    <Select
                      {...this.props.monthsOfGraceSelect}
                      change={this._selectHandler}
                    />
                  </div>
                ) : null}
              </div>
            </Col>
          ) : null}
        </Row>
      </Container>
    );
  }

  private _deferredTypeSelectHandler(_: string, newValue: string): void {
    this.props.updateDeferredType(newValue);
  }

  private _selectHandler(id: string, newValue: string): void {
    this.props.updateSelectValue({ ...this.props[id], value: newValue });
  }

  private _checkValidity(): boolean {
    return Object.keys(this.props.optionsFetch).length > 0;
  }
}

const mapStateToProps: (state: CajitaStore) => IDeferredOptionsProps = (
  state: CajitaStore
): IDeferredOptionsProps => ({
  ...state.card.deferredOptionsComponent,
  enabled: state.card.isDeferred,
  card: {
    binNumber: state.card.cardNumber.value
      .split(state.card.cardNumber.separator)
      .join("")
      .substr(0, 8),
  },
});

const mapDispatchToProps: (dispatch: Dispatch) => object = (
  dispatch: ThunkDispatch<CajitaStore, undefined, CardAction>
): object => ({
  fetchDeferredOptions: (binNumber: string, language: string): void =>
    dispatch(getDeferredOptions(binNumber, language)),
  updateDeferredType: (type: string): CardAction =>
    dispatch(changeDeferredTypeAction(type)),
  updateSelectValue: (select: ISelectProps): CardAction =>
    dispatch(updateDeferredSelectValue(select)),
  updateValidity: (): CardAction => dispatch(deferredOptionsValidityAction()),
  switchIsDeferred: (): CardAction => dispatch(switchIsDeferred()),
});

const DeferredOptionsComponent: React.ComponentClass = connect<
  IDeferredOptionsProps,
  {},
  {},
  CajitaStore
>(
  mapStateToProps,
  mapDispatchToProps
)(
  withLocalize<
    IDeferredOptionsProps & { enabled: boolean } & LocalizeContextProps
  >(DeferredOptions)
);

export { DeferredOptionsComponent };



// WEBPACK FOOTER //
// ./src/components/DeferredOptions/DeferredOptionsComponent.tsx